import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forecast-interpretation-settings',
  templateUrl: './forecast-interpretation-settings.component.html',
  styleUrls: ['./forecast-interpretation-settings.component.scss']
})
export class ForecastInterpretationSettingsComponent implements OnInit {

  constructor() { }
  Last3Inspection: boolean = false;
  FleetAverage: boolean = false;
  loading: boolean = false;
  scenarioA: boolean = false;
  scenarioB: boolean = false;
  scenarioC: boolean = false;
  lastThreeInspectionUsage: number;
  scenarioUsageA: number;
  scenarioUsageB: number;
  scenarioUsageC: number;
  lastThreeInspectionDistance: number;
  scenarioDistanceA: number;
  scenarioDistanceB: number;
  scenarioDistanceC: number;
  rateFactor: number;
  distance: boolean = false;
  cmu: boolean = false;
  upHours: number;
  downHours: number;
  currentSMU: number;
  dist: number;
  nextServiceDate: Date;
  followingServiceDate: Date;
  floatingServiceDate: Date;
  ngOnInit() {
  }

  NextServiceDateChange(event) {
    this.nextServiceDate = event.value;
      if ((new Date(this.followingServiceDate) >= event.value) &&(new Date(this.followingServiceDate) <= event.value)
      ) {
        
      }

  }

  FollowingDateChange(event) {
    this.followingServiceDate = event.value;
      if ((new Date(this.followingServiceDate) >= event.value) &&(new Date(this.followingServiceDate) <= event.value)
      ) {
        
      }

  }

  FloatingDateChange(event) {
    this.floatingServiceDate = event.value;
      if ((new Date(this.followingServiceDate) >= event.value) &&(new Date(this.followingServiceDate) <= event.value)
      ) {
        
      }

  }
}
